export const isMenuPageOpen = state => {
    return state && state.page.pageType === 'MENU_PAGE';
}


// WEBPACK FOOTER //
// ./src/selectors/page_selectors.js